import type { Context } from 'react';
import { useContext } from 'react';

export function useRequiredContext<T>(context: Context<T>): NonNullable<T> {
  const value = useContext(context);
  if (value === null || value === undefined) {
    throw new Error(
      `Required context '${context.displayName}' is not provided`,
    );
  }
  return value as NonNullable<T>;
}
